import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <section className="bi-terms">

      {/* ================= HERO ================= */}
      <div className="bi-terms-hero">
        <div className="bi-terms-container">

          <div className="bi-terms-hero-grid">

            <div>
              <span className="bi-terms-kicker">
                BEST INDUSTRIES / LEGAL
              </span>

              <h1>
                Terms
                <span> & Conditions</span>
              </h1>

              <p>
                Please read these terms carefully before using the
                Best Industries website, products or services.
              </p>
            </div>

            <div className="bi-terms-stamp">
              <div className="bi-terms-stamp-circle">
                <span>BI</span>
              </div>

              <strong>TERMS</strong>
              <small>USE • SERVICE • RESPONSIBILITY</small>
            </div>

          </div>

        </div>
      </div>


      {/* ================= BODY ================= */}
      <div className="bi-terms-container">

        <div className="bi-terms-layout">

          {/* SIDEBAR */}
          <aside className="bi-terms-sidebar">

            <div className="bi-terms-side-heading">
              TERMS
              <span>CONTENTS</span>
            </div>

            <a href="#acceptance">01 / Acceptance</a>
            <a href="#website">02 / Website Usage</a>
            <a href="#services">03 / Services</a>
            <a href="#information">04 / Information</a>
            <a href="#intellectual">05 / Intellectual Property</a>
            <a href="#responsibility">06 / Responsibility</a>
            <a href="#thirdparty">07 / Third Party</a>
            <a href="#changes">08 / Changes</a>
            <a href="#contact">09 / Contact</a>

          </aside>


          {/* CONTENT */}
          <main className="bi-terms-content">

            {/* 01 */}
            <article id="acceptance" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>01</span>
                <h2>Acceptance of Terms</h2>
              </div>

              <p>
                By accessing and using the Best Industries website,
                you agree to comply with and be bound by these Terms
                & Conditions.
              </p>

              <p>
                If you do not agree with any part of these terms,
                please do not use our website or services.
              </p>

              <div className="bi-terms-notice">
                <strong>PLEASE NOTE</strong>

                <span>
                  Your continued use of this website means that you
                  accept these terms and any future updates.
                </span>
              </div>

            </article>


            {/* 02 */}
            <article id="website" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>02</span>
                <h2>Website Usage</h2>
              </div>

              <p>
                The Best Industries website is provided to give
                visitors information about our company, capabilities,
                products and services.
              </p>

              <p>
                You agree to use the website only for lawful purposes
                and in a manner that does not interfere with the
                operation, security or availability of the website.
              </p>

              <div className="bi-terms-points">

                <div>
                  <b>01</b>
                  <span>Use the website lawfully.</span>
                </div>

                <div>
                  <b>02</b>
                  <span>Do not attempt unauthorized access.</span>
                </div>

                <div>
                  <b>03</b>
                  <span>Do not misuse website content.</span>
                </div>

                <div>
                  <b>04</b>
                  <span>Do not interfere with website operation.</span>
                </div>

              </div>

            </article>


            {/* 03 */}
            <article id="services" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>03</span>
                <h2>Products & Services</h2>
              </div>

              <p>
                Best Industries provides industrial products,
                fabrication services, engineering solutions and
                other services according to customer requirements.
              </p>

              <p>
                Product specifications, availability, pricing,
                delivery schedules and service details may vary
                depending on the nature and requirements of each
                project.
              </p>

              <div className="bi-terms-service-grid">

                <div>
                  <span>01</span>
                  <strong>Fabrication</strong>
                  <p>
                    Industrial fabrication and customized solutions.
                  </p>
                </div>

                <div>
                  <span>02</span>
                  <strong>Engineering</strong>
                  <p>
                    Solutions designed around specific requirements.
                  </p>
                </div>

                <div>
                  <span>03</span>
                  <strong>Custom Work</strong>
                  <p>
                    Specialized products and industrial requirements.
                  </p>
                </div>

              </div>

            </article>


            {/* 04 */}
            <article id="information" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>04</span>
                <h2>Information Provided by Users</h2>
              </div>

              <p>
                When you contact Best Industries through our website,
                you may provide information such as your name, email
                address, telephone number, company details and
                requirements.
              </p>

              <p>
                You are responsible for ensuring that the information
                you provide is accurate and complete.
              </p>

              <div className="bi-terms-data-row">

                <div>
                  <span>NAME</span>
                  <strong>Customer Details</strong>
                </div>

                <div>
                  <span>CONTACT</span>
                  <strong>Email / Phone</strong>
                </div>

                <div>
                  <span>REQUIREMENT</span>
                  <strong>Project Information</strong>
                </div>

              </div>

            </article>


            {/* 05 */}
            <article id="intellectual" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>05</span>
                <h2>Intellectual Property</h2>
              </div>

              <p>
                Unless otherwise stated, the content displayed on
                the Best Industries website, including text, graphics,
                logos, images, designs and other materials, belongs
                to or is used by Best Industries.
              </p>

              <p>
                Website content may not be copied, reproduced,
                modified, distributed or commercially used without
                appropriate permission.
              </p>

              <div className="bi-terms-property">

                <div className="bi-terms-property-icon">
                  ©
                </div>

                <div>
                  <strong>BEST INDUSTRIES</strong>
                  <span>
                    Content • Branding • Design • Information
                  </span>
                </div>

              </div>

            </article>


            {/* 06 */}
            <article id="responsibility" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>06</span>
                <h2>User Responsibility</h2>
              </div>

              <p>
                Users are expected to use the website responsibly
                and respect applicable laws and regulations.
              </p>

              <div className="bi-terms-responsibility">

                <div>
                  <strong>RESPONSIBLE USE</strong>
                  <p>
                    Use our website and services for legitimate
                    purposes only.
                  </p>
                </div>

                <div>
                  <strong>ACCURATE DETAILS</strong>
                  <p>
                    Provide correct information when submitting
                    an enquiry.
                  </p>
                </div>

                <div>
                  <strong>RESPECT</strong>
                  <p>
                    Do not misuse our website, systems or content.
                  </p>
                </div>

              </div>

            </article>


            {/* 07 */}
            <article id="thirdparty" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>07</span>
                <h2>Third-Party Links</h2>
              </div>

              <p>
                Our website may contain links or references to
                third-party websites or services. These links may
                be provided for convenience or additional information.
              </p>

              <p>
                Best Industries does not necessarily control or
                endorse the content, policies or practices of
                external websites.
              </p>

            </article>


            {/* 08 */}
            <article id="changes" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>08</span>
                <h2>Changes to These Terms</h2>
              </div>

              <p>
                Best Industries may update or modify these Terms &
                Conditions from time to time. Changes may be made
                to reflect improvements to our website, services or
                business practices.
              </p>

              <p>
                We encourage visitors to review this page periodically
                to stay informed about the current terms.
              </p>

              <div className="bi-terms-update">

                <span>KEEP UPDATED</span>

                <strong>
                  Review this page periodically for changes.
                </strong>

              </div>

            </article>


            {/* 09 */}
            <article id="contact" className="bi-terms-article">

              <div className="bi-terms-heading">
                <span>09</span>
                <h2>Contact Best Industries</h2>
              </div>

              <p>
                If you have questions regarding these Terms &
                Conditions, you can contact Best Industries using
                the details below.
              </p>

              <div className="bi-terms-contact">

                <div>
                  <span>COMPANY</span>
                  <strong>BEST INDUSTRIES</strong>
                </div>

                <div>
                  <span>PHONE</span>
                  <strong>+91 72996 05040</strong>
                </div>

                <div>
                  <span>EMAIL</span>
                  <strong>booking@bestindustries.in</strong>
                </div>

                <div>
                  <span>ADDRESS</span>
                  <strong>
                    No 431, 7th Street (North Phase), SECTOR-1, Ambattur Industrial Estate, Sidco Industrial Estate, Ambattur, Chennai, Tamil Nadu 600098
                  </strong>
                </div>

              </div>

            </article>


            {/* FINAL */}
            <div className="bi-terms-final">

              <span>BEST INDUSTRIES</span>

              <h3>
                Built on quality.
                <strong> Driven by trust.</strong>
              </h3>

              <p>
                Thank you for choosing Best Industries. We look
                forward to serving your industrial requirements
                with quality, reliability and commitment.
              </p>

            </div>

          </main>

        </div>

      </div>

    </section>
  );
};

export default TermsConditions;
